import { memo } from 'react';
import { Button as ButtonAnt, ButtonProps } from 'antd';

const Button: React.FC<ButtonProps> = ButtonAnt;

export default memo(Button);
